import React from 'react';
import PubLabPage from '../pubLab/PubLabPage.js';


function LabConsollePage(props) {
    const isAdmin = props.apiAuthGroups && props.apiAuthGroups.includes('ADMIN');

    return (
        <React.Fragment>
            <br />
            <PubLabPage
                apiAuthResponse={props.apiAuthResponse}
                apiAuthName={props.apiAuthName}
                apiAuthSurname={props.apiAuthSurname}
                apiAuthGroups={props.apiAuthGroups}
                isAdmin={isAdmin}
            />
            <br />
            <br />
        </React.Fragment>
    );
}

export default LabConsollePage;